import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiPayloadCreator } from "util/api";
import { selectAuthToken } from "redux/features/auth";

const apiCall = createAsyncThunk(
  "verifyEmail/codeCall",
  apiPayloadCreator("/email-addresses", "post")
);

export const verifyEmailSlice = createSlice({
  name: "verifyEmail",
  initialState: {
    sent: {},
  },
  reducers: {},
  extraReducers: {
    [apiCall.pending]: (state, action) => {
      const { person_id, address } = action.meta.arg.data;
      if (!state[person_id]) state[person_id] = {};
      state[person_id][address] = { sending: true };
    },
    [apiCall.fulfilled]: (state, action) => {
      const { person_id, address } = action.meta.arg.data;
      if (!state[person_id]) state[person_id] = {};
      state[person_id][address] = { sent: true };
    },
    [apiCall.rejected]: (state, action) => {
      const { person_id, address } = action.meta.arg.data;
      if (!state[person_id]) state[person_id] = {};
      state[person_id][address] = { failed: action.payload };
    },
  },
});

verifyEmailSlice.selector = (store) => store.verifyEmail;

verifyEmailSlice.asyncActions = {
  sendCode: ({ id, address }) => (dispatch) => {
    return dispatch(
      apiCall({
        selectAuthToken,
        data: { person_id: id, address, send_verification_code: true },
      })
    );
  },
};

export default verifyEmailSlice.reducer;
